import { versionCompare } from '../../version';
import Detector from '../../detector';
import defaultStrategy from './default-login';

// 探途旅行支持原生登录的版本
const travelVersion = '1.9.0';

export default {
  name: 'tantutravel',
  isLogin: defaultStrategy.isLogin,
  gotoLogin() {
    const zzc = window.zzc;
    if (zzc && versionCompare(Detector.browser.fullVersion, travelVersion)) {
      return zzc.call('page_linkTo', {
        url: '/login/',
        success(response) { console.log(response); }
      });
    }
    return defaultStrategy.gotoLogin();
  },
  clearLogin: defaultStrategy.clearLogin
};
